import ProjectUsersCollection from "../../../model2/project-user/collection"
import ProjectUser from "../../../model2/project-user/project-user"

export default function ProjectUser_checkDelete(projectUser: ProjectUser, projectUsers: ProjectUsersCollection) {

    let canDelete = true
    let reasonCantDelete = null

    // check not last full access user
    if (projectUser.access === gd.const.project.access.FULL && projectUsers.findFullAccessUsers().length <2) {
        canDelete = false
        reasonCantDelete = "At least one user with full access is required"
    }

    // check not Project owner
    if (projectUser.projectRole === gd.const.project.role.OWNER) {
        canDelete = false
        reasonCantDelete = "Project owner cannot be removed";
    }

    // we dont' do it anymore
    // // check not Project manager
    // if (projectUser.projectRole === gd.const.project.role.PROJECT_MANAGER) {
    //     canDelete = false;
    //     reasonCantDelete = "Project manager cannot be removed";
    // }

    //dont' delete inherited / upherited users...
    if (projectUser.inheritance !== 0) {
        canDelete = false;
        reasonCantDelete = "You cannot remove inherited users because the access mode is set to Inherited. To manage users manually, switch the access mode to Custom."
    }

    // check not full access user (Organization/Settings/Full access)
    if (gd.ac.check.company.isFullAccess(projectUser.userId)) {
        canDelete = false;
        reasonCantDelete = "Organization managers or administrators cannot be removed."
    }

    return {
        canDelete,
        reasonCantDelete
    }
}